define('pimSearchCompareView',[
  'module',
  'marionette',
  'app',
  'jquery',
  'underscore',
  'pimUtil',
  'pimSearchCompareColumnView',
  'template!pimSearchCompareTpl',
  'entities/pim_product'
], function (
  module,
  Marionette,
  App,
  $,
  _,
  PimUtil,
  ColumnView,
  layoutTpl
) {
  'use strict';

  var PimSearchCompareView = Marionette.LayoutView.extend({
    template: layoutTpl,
    className: 'pim-compare-page',

    ui: {
      columns: '.js-compare-columns',
      quantity: '.js-compare-qty',
      calcAll: '.js-compare-calc-all',
      blockLoading: '.js-compare-loading'
    },

    events: {
      'click .js-compare-back': 'onBackClick',
      'click .js-compare-clear-all': 'onClearAllClick',
      'click @ui.calcAll': 'onCalcAllClick',
      'change @ui.quantity': 'onSharedQtyChange',
      'input @ui.quantity': 'onSharedQtyChange'
    },

    initialize: function () {
      this._columns = [];
      this.sharedQty = 50;
    },

    serializeData: function () {
      return {
        count: (this.options.productIds || []).length,
        sharedQty: this.sharedQty
      };
    },

    onBackClick: function () {
      App.navigate('pim/search', {trigger: true});
    },

    onClearAllClick: function () {
      this.trigger('compare:clear');
    },

    onSharedQtyChange: function () {
      var v = parseInt(this.ui.quantity.val(), 10);
      if (!isNaN(v) && v > 0) {
        this.sharedQty = v;
        _.each(this._columns, function (col) {
          col.setQuantity(v);
        });
      }
    },

    onCalcAllClick: function () {
      var qty = parseInt(this.ui.quantity.val(), 10) || this.sharedQty;
      this.sharedQty = qty;
      _.each(this._columns, function (col) {
        col.setQuantity(qty);
        col.compute();
      });
    },

    onRender: function () {
      var that = this;
      _.each(this._columns || [], function (col) {
        try { col.destroy(); } catch (e) { /* no-op */ }
      });
      this._columns = [];
      this.ui.columns.empty();
      this.ui.blockLoading.show();

      var ids = this.options.productIds || [];

      if (!ids.length) {
        this.ui.blockLoading.hide();
        return;
      }

      // Fetch each pim product independently, keyed by position. We avoid
      // $.when.apply(...) here because its argument unpacking is ambiguous
      // when promises are produced via `.then(fn)` chaining — in production
      // (minified) builds the args sometimes collapse and only the first
      // model survived the loop.
      var pending = ids.length;
      var models = new Array(ids.length);
      var anyFailure = false;

      var finalize = function () {
        var rendered = 0;
        _.each(models, function (model) {
          if (!model) { return; }
          if (model.setCurrentResProduct) {
            model.setCurrentResProduct(null);
          }
          var column = new ColumnView({
            pimProduct: model,
            initialQuantity: that.sharedQty
          });
          that.listenTo(column, 'column:remove', _.bind(that.onColumnRemove, that, model));
          that.listenTo(column, 'column:price', _.bind(that._highlightCheapest, that));
          that._columns.push(column);
          column.render();
          that.ui.columns.append(column.$el);
          rendered++;
        });

        that.$el.attr('data-col-count', String(rendered));
        that.ui.blockLoading.hide();

        if (rendered === 0 && anyFailure && window.bootbox && window.bootbox.alert) {
          window.bootbox.alert(_.i18n('compare.fetchError', null, 'Failed to load products to compare'));
        }
      };

      _.each(ids, function (id, idx) {
        var model = App.request('pim:products:model', {id: id});
        var done = function () {
          pending--;
          if (pending <= 0) { finalize(); }
        };
        model.fetch()
          .done(function () { models[idx] = model; })
          .fail(function () { anyFailure = true; })
          .always(done);
      });
    },

    onColumnRemove: function (model) {
      this.trigger('compare:remove', model.get('id'));
    },

    _highlightCheapest: function () {
      var best = null;
      _.each(this._columns, function (col) {
        var p = col._lastPrice;
        if (p && (best === null || p.total < best.total)) {
          best = { total: p.total, col: col };
        }
      });
      _.each(this._columns, function (col) {
        if (best && col === best.col) {
          col.$el.addClass('is-cheapest');
        } else {
          col.$el.removeClass('is-cheapest');
        }
      });
    },

    onDestroy: function () {
      _.each(this._columns, function (col) {
        try { col.destroy(); } catch (e) { /* no-op */ }
      });
      this._columns = [];
    }
  });

  module.exports = PimSearchCompareView;
});

